import { ArsTableState, ArstActionSetViewItem } from "../interface";

/**
 * Sets the view item in the ArsTable state.
 *
 * @param state - Current state of the ArsTable
 * @param action - Action containing the view item to be set
 */
export const arst_setViewItem = <T>(
  state: ArsTableState<T>,
  action: ArstActionSetViewItem,
): ArsTableState<T> => {
  return {
    ...state,
    viewItem: action.viewItem,
  };
};
